// Add your custom JS here.
import { jarallax } from "jarallax";

jarallax(document.querySelectorAll('.jarallax'), {});
